import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import padlockImg from "../assets/images/padlock.svg";
import ptoolsImg from "../assets/images/p-tools.png";
import pcusImg from "../assets/images/p-customer.png";
import pmetImg from "../assets/images/p-methods.png";
import pcidImg from "../assets/images/pcidss.svg";

const Home = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section>
        <div className="home container">
          <div className="header main">
            <p className="first">THE MARKETPLACE FOR FINANCIAL SERVICES</p>
            <h1>Simplified payments for smarter businesses.</h1>
            <p className="second">
              Swift Tech Pay enables local and global businesses to sell, build
              and scale effortlessly with powerful payment solutions. Start
              growing your business today.
            </p>
            <Link to="/contact">
              <small>
                Have questions? <span>Contact our sales team</span>
              </small>
            </Link>
          </div>
        </div>
        <hr className="home hr" />
        <div className="container">
          <div className="padlock-wrapper">
            <img src={padlockImg} alt="padlock-img" />
            <div className="padlock-content">
              <p>We care about protecting your private and personal data:</p>
              <p>Learn more</p>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-dark-blue">
        <div className="section-two container">
          <div className="part-one">
            <h2>Connect your business to payment tools that work.</h2>
            <p className="desc">
              Our suite of plug-and-play tools and payment applications enable
              fintechs and individuals set up their businesses in the shortest
              possible time.
            </p>
            <div className="list-wrapper">
              <div className="box-wrapper">
                <div className="box">
                  <div className="child"></div>
                </div>
              </div>
              <p>Easy integrations with apps / websites</p>
            </div>
            <div className="list-wrapper">
              <div className="box-wrapper">
                <div className="box">
                  <div className="child"></div>
                </div>
              </div>
              <p>Fast, frictionless cash flow</p>
            </div>
          </div>
          <div className="part-two">
            <img src={ptoolsImg} alt="ptools-img" />
          </div>
        </div>
      </section>
      <section className="bg-dark-blue">
        <div className="section-three container">
          <div className="part-one">
            <div className="img-wrap">
              <img src={pcusImg} alt="pcust-img" />
            </div>
            <h2>Enjoy optimized merchant-customer experience.</h2>
            <p className="desc">
              Swift Tech Pay enables merchants to build superior
              customer-centric payment experiences that really set them apart.
            </p>
            <div className="list-wrapper">
              <div className="box-wrapper">
                <div className="box">
                  <div className="child"></div>
                </div>
              </div>
              <p>Data-rich customer analytics</p>
            </div>
          </div>
          <div className="part-two">
            <h2>Pay and get paid without stress.</h2>
            <p className="desc">
              Create flexible payment methods for customers with Swift Tech
              Pay's customizable checkouts and smart invoicing tools to save
              time and money.
            </p>
            <div className="list-wrapper">
              <div className="box-wrapper">
                <div className="box">
                  <div className="child"></div>
                </div>
              </div>
              <p>Multi-channel payment collections</p>
            </div>
            <div className="img-wrap">
              <img src={pmetImg} alt="pmet-img" />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="section-four container">
          <div className="header next">
            <p className="first">PAYMENTS MADE EASY</p>
            <h1>Easy to set up. Effortless to use.</h1>
            <p className="second">
              Getting paid or paying your customers doesn’t have to be slow and
              stressful. Swift Tech Pay's payment engine conveniently takes
              collecting and disbursing funds to a whole new level—it’s simpler
              and faster.
            </p>
            <small>
              We take your data protection seriously. See our{" "}
              <span>Privacy Policy</span>
            </small>
          </div>
        </div>
      </section>
      <section className="section-five-wrapper">
        <div className="section-five container">
          <img src={pcidImg} alt="pcid-img" />
          <h5>Swift Tech Pay is PCI DSS compliant.</h5>
          <p>
            This means that we take standard security measures to ensure your
            sensitive payment information are always safe.
          </p>
        </div>
      </section>
      <section className="section-six-wrapper">
        <div className="section-six container">
          <h3>
            Questions? <span>Talk to us.</span>
          </h3>
          <p>
            Get in touch with us to see how Swift Tech Pay can help you scale
            your business. Our customer success teams are always available to
            walk you through getting started.
          </p>
          <Link to="/contact">
            <button>Contact Sales</button>
          </Link>
        </div>
      </section>
    </>
  );
};

export default Home;
